import './page/stopword-list';

Shopware.Module.register('topdata-es-mining-stopword', {
    type: 'plugin',
    name: 'Mining stopwords',
    title: 'TopdataEnhancedSearchSW6.topdata-es-mining-stopword.title',
    description: 'TopdataEnhancedSearchSW6.topdata-es-mining-stopword.description',
    color: '#189eff',
    icon: 'default-shopping-search',

    routes: {
        list: {
            component: 'topdata-es-mining-stopword-list',
            path: 'list',
            meta: {
                privilege: 'system.zero_search.viewer',
            },
        },
    },

    navigation: [{
        id: 'topdata-es-mining-stopword-list',
        label: 'TopdataEnhancedSearchSW6.topdata-es-mining-stopword.listTitle',
        color: '#189eff',
        path: 'topdata.es.mining.stopword.list',
        parent: 'topdata-es',
    }],
});
